import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Places from './Places';
import Users from './Users';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    places: Places,
    users: Users,
});

export default reducers;
